<div class="orbitron">
    <h1>Deckplan.io</h1>
    Something bad has happened!<br>
    <span (click)="goBack()" matRipple>Go Back!</span><br>
    <span (click)="goToLanding()" matRipple>Go to Landing Page</span>
</div>